(() => {
  document.querySelectorAll('[data-home-reviews]').forEach(root => {
    if (root.dataset.homeReviewsReady) return;
    root.dataset.homeReviewsReady = 'true';
    const track = root.querySelector('[data-home-review-track]');
    const previous = root.querySelector('[data-home-review-prev]');
    const next = root.querySelector('[data-home-review-next]');
    const dialog = root.querySelector('[data-home-review-dialog]');
    const content = root.querySelector('[data-home-review-content]');
    const close = root.querySelector('[data-home-review-close]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let trigger = null;
    let frame = 0;

    const updateArrows = () => {
      frame = 0;
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    };
    const scheduleUpdate = () => {
      if (!frame) frame = requestAnimationFrame(updateArrows);
    };
    const scroll = (direction, page = false) => {
      const slide = track.querySelector('[data-home-review-id]');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (page ? track.clientWidth : slide.getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(scheduleUpdate).observe(track);
    track.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (['ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown'].includes(event.key)) {
        event.preventDefault();
        scroll(['ArrowLeft', 'PageUp'].includes(event.key) ? -1 : 1, event.key.startsWith('Page'));
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
    });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-home-review-open]');
      if (!button || !root.contains(button) || dialog.open) return;
      const template = button.closest('[data-home-review-id]').querySelector('[data-home-review-detail]');
      if (typeof dialog.showModal !== 'function') return;
      trigger = button;
      content.replaceChildren(template.content.cloneNode(true));
      dialog.showModal();
      document.documentElement.classList.add('muse-home-review-open');
      close.focus();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') event.stopPropagation();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('muse-home-review-open');
      content.replaceChildren();
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      trigger = null;
    });
    updateArrows();
  });
})();
